import { CustomBoxV2 } from "components";
import { PuttingIcon } from "pages/internal-dashboard/icons";

export function Putting({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#1C1C1D"
      title="Putting"
      userCount={data?.total || 0}
      boxData={{
        label: "Putting",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: PuttingIcon,
      }}
      percentages={percentages}
    />
  );
}
